import './BookTranslationStyle.css'
import { useAppDispatch } from "../../../../store/hooks";
import { bookEditorActions } from "../slice";
import { Book, Language } from "../../../../rest/models";
import { QueryTranslationButtonUnsaved } from "./QueryTranslationButtonUnsaved";
import { QueryTranslationButtonSaved } from "./QueryTranslationButtonSaved";
import { TextArea } from "../../../RequestRespectingInputs";

export function BookTranslationEdit(props: Props)
{
    const appDispatch = useAppDispatch();
    const {
        book,
        text,
        sourceLanguage: sl,
        targetLanguage: tl,
        sourceTextChanged} = props;

    const slCode = sl?.gtrans_code || 'auto';
    const tlCode = tl.gtrans_code;
    const isTlSource = tl.id === sl?.id;

    const bookUnsaved = !book.id || sourceTextChanged;

    function googlify(url: string)
    {
        if (isTlSource)
        {
            return url;
        }
        
        const params = new URLSearchParams();
        params.set('sl', slCode);
        params.set('tl', tlCode);
        params.set('u', url);
        params.set('client', 'webapp');
        
        return `https://translate.google.com/translate?${params}`;
    }

    //The translation must have a line for every sentence in the text.
    //But we'll make an exception for the initial state, when the field is empty.
    const sentenceCountMismatch = 
        (book.sentence_set.length !== text.trim().split('\n').length) && text;

    const warning = !text.trim()
    ? <p className='ernots_Warning'>The translation is empty.</p>
    : sentenceCountMismatch
    ? <div className='ernots_Warning'>
        <p>
            To avoid misalignment, the number of lines in this translation needs to match the number of sentences in the book. 
          </p>
          <p>
            If you need to make edits, you can edit, merge or split individual sentences in the Read view.
          </p>
      </div>
      : <></>;

    const buttonText = `Open ${tl.name} translation`;
    let legendText = `${tl.name} (original text)`;
    if (tl.id !== sl?.id)
    {
        legendText = `${tl.name} translation`
    }
    
    //This allows us to open a webpage listing the sentences in the book.
    //If the target language differs from the source language,
    //we redirect to a Google Translate page that translates the whole thing for us.
    const button = tl.id === sl?.id
        ? <></>
        : bookUnsaved
        ? <QueryTranslationButtonUnsaved book={book} buttonText={buttonText} tlCode={tlCode} googlify={googlify}/>
        : <QueryTranslationButtonSaved bookId={book.id} buttonText={buttonText}
            sourceTextEmpty={!book.source_text.length} googlify={googlify}/>;
    
    //Each language, including the source, has a textarea. You must copy the text into it for it to show up in the reading view.
    //One sentence per line.
    //For the source language, the text is filled automatically.
    return (
    <fieldset className='ernots_BookTranslationEdit'>
        <legend>{legendText}</legend>

        {warning}
        <TextArea
            id={'translated_text_' + tl.name}
            value={props.text}
            readOnly={tl.id === sl?.id}
            onChange={(e) => appDispatch(bookEditorActions.setTranslation([tl.id, e.target.value]))}/>
        <br/>
        {button}
    </fieldset>);
}

interface Props
{
    book: Book;
    targetLanguage: Language;
    sourceLanguage?: Language;
    text: string;
    sourceTextChanged: boolean;
}